import Navbar from "@/components/Navbar";
import ProductSwitcher from "@/components/ProductSwitcher";
import { HERO_IMG } from "@/data/content";

export default function Hero() {
  return (
    <section
      className="relative min-h-[88vh] md:min-h-[100vh] grain overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(10,10,11,0.55), rgba(10,10,11,0.85)), url(${HERO_IMG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="hero"
    >
      <Navbar dark />
      <div className="px-5 md:px-12 lg:px-24 pt-24 md:pt-44 pb-12 md:pb-20">
        <div className="max-w-4xl">
          <p className="tcp-overline text-[#C29B62] mb-3 md:mb-6 fade-in" data-testid="hero-overline">
            A US Premium Travel Arranger
          </p>
          <h1
            className="font-serif text-[#F7F5F0] text-4xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-medium hero-text fade-in"
            data-testid="hero-title"
          >
            Two cities. <br />
            One unforgettable <em className="italic" style={{ color: "#C29B62" }}>arrival</em>.
          </h1>
          <p className="text-[#A09E9A] text-sm md:text-lg mt-4 md:mt-8 max-w-xl leading-relaxed fade-in" data-testid="hero-sub">
            Curated premium and business class fares from the United States to the world's most considered destinations — booked in under sixty seconds.
          </p>
        </div>

        <div className="mt-6 md:mt-16">
          <ProductSwitcher />
        </div>

        <div className="mt-6 md:mt-10 grid grid-cols-1 md:flex md:flex-wrap items-start md:items-center gap-y-2 md:gap-y-3 md:gap-x-10 text-[11px] md:text-xs tracking-wider text-[#A09E9A]">
          <span data-testid="trust-secure">✓ Secure 256-bit Booking</span>
          <span data-testid="trust-bestprice">✓ Best Price Guarantee</span>
          <span data-testid="trust-instant">✓ Instant E-ticket Confirmation</span>
        </div>
      </div>
    </section>
  );
}
